import { TrackingProp } from 'react-tracking';
import { useEffect } from 'react';
import { CheckoutStepViewedEvent } from '../analyticsWrapper';
import { CheckoutStep, createCheckoutStepEventProperties } from '../tracking';
import { Cart__Patched } from '../../../pages/checkout/cart';
import { useProductSLA } from '../../../hooks/useProductSLA';

export function useTrackCheckoutStepViewed(
  tracking: TrackingProp<CheckoutStepViewedEvent>,
  checkoutId: number | undefined,
  stepKey: CheckoutStep,
  cart: Cart__Patched,
  stepAutoCompleted = false,
  ...deps: any[]
): void {
  const { getLongestSLAFromCart } = useProductSLA();
  const longestSLA = getLongestSLAFromCart(cart);

  const dependencies = [checkoutId, longestSLA, ...deps];
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps    
  useEffect(() => trackCheckoutStepViewed(tracking, checkoutId, stepKey, cart, longestSLA, stepAutoCompleted), dependencies);
}

function trackCheckoutStepViewed(
  tracking: TrackingProp<CheckoutStepViewedEvent>,
  checkoutId: number | undefined,
  stepKey: CheckoutStep,
  cart: Cart__Patched,
  longestSLA = null,
  stepAutoCompleted: boolean
) {
  if (checkoutId) {
    const data = createCheckoutStepEventProperties(stepKey, checkoutId, stepAutoCompleted, cart, longestSLA);
    tracking.trackEvent({ type: 'checkoutStepViewed', data });
  }
}
